import { render } from "./line_chart.svg?vue&type=template&id=9613eb82"
const script = {}
script.render = render

export default script